"use strict"
module.exports = {...require('./methods'), apiURL: require('./apiURL')}